import type { JSX, ReactNode } from 'react'

import { clsx } from 'clsx'

import { Card, Flex, Text } from '@buffer-mono/popcorn'

import { DraftBadge } from '~publish/components/PostStatusBadge'

import styles from './CalendarUndatedDraftCard.module.css'

export function CalendarUndatedDraftCard({
  text,
  networks,
  media,
}: {
  text: string
  networks?: ReactNode
  media?: ReactNode
}): JSX.Element {
  return (
    <Card className={clsx(styles.card, media && styles.cardWithMedia)}>
      <Flex direction="column" gap="xs" align="start">
        {networks ? (
          <Flex gap="xs" align="center">
            <DraftBadge />
            {networks}
          </Flex>
        ) : (
          <DraftBadge />
        )}
        <Text className={styles.text}>{text}</Text>
      </Flex>
      {media ? <div className={styles.media}>{media}</div> : null}
    </Card>
  )
}
